<mat-selection-list class="listFacilities" (selectionChange)="onChangeSlot(slotList.selectedOptions.selected)"
    #slotList>
    <mat-list-option class="listSlotOption" *ngFor="let slot of slots_to_show" [value]="slot">
        {{slot.startDateTime | date:'HH:mm'}} - {{(slot | slotStatus | translate)
        .replace("%1",slot.endDateTime | date:'HH:mm')
        .replace("%2",slot.reservation?slot.reservation.firstName + " " + slot.reservation.lastName:"")}}
        {{slot.reservation? "- " + slot.reservation.title:""}}
    </mat-list-option>
</mat-selection-list>